import { render } from "./FamilyBlock.vue?vue&type=template&id=07ecd25a"
import script from "./FamilyBlock.vue?vue&type=script&lang=js"
export * from "./FamilyBlock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Freaz/rk/rk.off-vue/rk.off-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__